import React from 'react'
import Container from '@material-ui/core/Container';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from "swiper";
import "swiper/css";
import "swiper/css/pagination";
import galeria1 from '../../assets/galeriacz1.jpg';
import galeria2 from '../../assets/galeriacz2.jpg';
import galeria3 from '../../assets/galeriacz3.jpg';
import galeria4 from '../../assets/galeriacz4.jpg';
import galeria5 from '../../assets/galeriacz5.jpg';
import galeria6 from '../../assets/galeriacz6.jpg';
import galeria7 from '../../assets/galeriacz7.jpg';
import galeria8 from '../../assets/galeriacz8.jpg';
import galeria9 from '../../assets/galeriacz9.jpg';



const Section3 = () => {
  return (
    <div id='proyecto' className='section noPadBot'>
        <Container className='relative flex flexCol relative'>
         
              <Swiper
                spaceBetween={30}
                grabCursor={true}
                pagination={{
                  clickable: true,
                }}
                autoplay={{
                  delay: 2500,
                  disableOnInteraction: false,
                }}
                modules={[Autoplay, Pagination]}
                className="galeriaSwiper shadow"
              >
                <SwiperSlide>
                  <img src={galeria1} alt="Glaeria 1" />
                </SwiperSlide>
                <SwiperSlide>
                  <img src={galeria2} alt="Glaeria 2" />
                </SwiperSlide>
                <SwiperSlide>
                  <img src={galeria3} alt="Glaeria 3" />
                </SwiperSlide>
                <SwiperSlide>
                  <img src={galeria4} alt="Glaeria 4" />
                </SwiperSlide>
                <SwiperSlide>
                  <img src={galeria5} alt="Glaeria 5" />
                </SwiperSlide>
                <SwiperSlide>
                  <img src={galeria6} alt="Glaeria 6" />
                </SwiperSlide>
                <SwiperSlide>
                  <img src={galeria7} alt="Glaeria 7" />
                </SwiperSlide>
                <SwiperSlide>
                  <img src={galeria8} alt="Glaeria 8" />
                </SwiperSlide>
                <SwiperSlide>
                  <img src={galeria9} alt="Glaeria 9" />
                </SwiperSlide>
              </Swiper>
              <div className="floatTitle shadow">
                <h2>Proyecto</h2>
                <p>Vivienda familiar desarrollada en planta baja de 103 m2 cubiertos, 5.5 m2 semicubiertos, patio interno de 15 m2, 50 m2 de terraza con parrilla y piscina, área de estacionamiento y jardines.</p>
              </div>
        </Container>
    </div>
  )
}

export default Section3